import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import {LicenseActivation} from "../../../models/license";

interface UserLicenseActivationProps {
    activation: LicenseActivation;
}

export default function UserLicenseActivation({ activation }: UserLicenseActivationProps) {
    return (
        <Card
            variant="outlined"
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-2px)',
                },
                borderColor: 'divider',
            }}
        >
            <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 600, fontSize: '1rem' }}>
                        Activation
                    </Typography>
                    <Chip
                        label={activation.is_active ? 'Active' : 'Inactive'}
                        size="small"
                        color={activation.is_active ? 'success' : 'default'}
                        variant={activation.is_active ? 'filled' : 'outlined'}
                    />
                </Box>
                <Divider sx={{ my: 1.5 }} />
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    <Box>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                            Activated At
                        </Typography>
                        <Typography variant="body2">
                            {activation.activated_at ? new Date(activation.activated_at).toLocaleString() : 'N/A'}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                            Last Validation Check
                        </Typography>
                        <Typography variant="body2">
                            {activation.last_seen ? new Date(activation.last_seen).toLocaleString() : 'N/A'}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
}
